import { ConfluenceSearchConfigModalWithWrappers } from './ConfluenceSearchConfigModalWithWrappers';

export const CONFLUENCE_SEARCH_DATASOURCE_ID = '768fc736-3af4-4a8f-b27e-203602bff8ca';

export default ConfluenceSearchConfigModalWithWrappers;
